import { useEffect } from 'preact/hooks';
import type { FiltersAndSort } from '@/widgets/services/FilteringAndSortingService';
import useQueryStringStore from '@/widgets/hooks/useQueryStringStore';
import type { PersistedState } from '../Store';
import type { ConfigUniqueId } from '@/domain/FilteringAndSorting';

// TODO: Switch back to Signals, once useQueryStringStore uses Signals
export function useFilteringAndSortingPersistence(
  filtersAndSort: FiltersAndSort
): void {
  const { filtering, sorting } = filtersAndSort;
  const [, setStores] = useQueryStringStore<PersistedState>();
  const currentFilters = filtering.currentFilters.value;
  const currentSort = sorting.currentSort.value?.id;

  useEffect(() => {
    const selections = currentFilters.map(
      ([filter, filterOption]) => `${filter.id}:${filterOption.id}`
    ) as `${ConfigUniqueId}:${ConfigUniqueId}`[];

    setStores({
      filters: selections.length ? selections : undefined
    });
  }, [currentFilters]);

  useEffect(() => {
    setStores({
      sort: currentSort
    });
  }, [currentSort]);
}
